import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ToastContainer, toast } from 'react-toastify';
import Paper from '@mui/material/Paper';
import { UilPen, UilTrash } from '@iconscout/react-unicons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function BankList({ data }) {
  const history = useNavigate();
  let message;
  const successNotification = (message) => toast.success(message);
  const errorNotification = (message) => toast.error(message);

  const onDelete = async (bankID) => {
    const res = await axios.delete(
      `${process.env.REACT_APP_API_URL}/marketers/delete-bank?bankID=${bankID}`
    );
    const response = res.data;
    if (res.status === 200) {
      successNotification(response.message);
      setTimeout(() => window.location.reload(), 1000);
    } else {
      errorNotification(response.message);
    }
  };
  return (
    <div className="Table withdrawalTable">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <h3>Bank Accounts</h3>
      <br />
      {data && (
        <TableContainer component={Paper} className="dashTable" style={{ height: 'auto' }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Bank Name</TableCell>
                <TableCell align="left">Account Name</TableCell>
                <TableCell align="left">Account Number</TableCell>
                <TableCell align="left">Account Type</TableCell>
                <TableCell align="left">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ color: 'white' }}>
              {data.map((row, index) => {
                return (
                  <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell align="left">{row.bankName}</TableCell>
                    <TableCell align="left">{row.accountName}</TableCell>
                    <TableCell align="left" className="amount">
                      {row.accountNumber}
                    </TableCell>
                    <TableCell align="left">
                      <span className="status">{row.accountType}</span>
                    </TableCell>
                    <TableCell align="left">
                      <UilPen
                        color="#121212"
                        size={28}
                        onClick=""
                        style={{ marginRight: '12px', cursor: 'pointer' }}
                      />
                      <UilTrash
                        color="#121212"
                        size={28}
                        onClick={() => onDelete(row.bankID)}
                        style={{ cursor: 'pointer' }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
}
